import { get, post } from 'common/utils/xhr';
import { get as getCookie } from 'cookies-js';

type Error = {
    param: string;
    message: string;
};

type LoginSuccessBody = {
    target: string;
};

export function login(email: string, password: string) {
    return authenticateLogin(email, password).then(postLogin);
}

function authenticateLogin(email: string, password: string) {
    const xhr = post('/accounts/xhr/login', {
        email: email,
        password: password,
        csrf_token: getCookie('_99csrf'),
    });

    return new Promise((resolve, reject) => {
        xhr.end((err, res) => {
            if (err) {
                if (res.status !== 400) {
                    reject(null);
                }

                const errors: { [key: string]: string } = {};
                const json = JSON.parse(res.text) as { errors: Error[] };

                if (json.errors) {
                    json.errors.forEach(error => (errors[error.param] = error.message));
                }
                reject(errors);
            } else {
                resolve(res.body);
            }
        });
    });
}

function postLogin(data: LoginSuccessBody) {
    const target = data.target.split('/')[2];

    const xhr = get(`/postlogin/xhr/${target}`);
    return new Promise((resolve, reject) => {
        xhr.end((err, res) => {
            if (err) {
                reject();
            } else {
                resolve();
            }
        });
    });
}

type Signup = {
    email: string;
    password: string;
    source?: string;
    hasAgreedToPrivacyAndTerms: boolean;
};

export function signup({ email, password, source, hasAgreedToPrivacyAndTerms }: Signup) {
    const xhr = post('/accounts/xhr/signup', {
        email: email,
        password: password,
        role: '',
        displayname: '',
        csrf_token: getCookie('_99csrf'),
        source: source,
        legals: hasAgreedToPrivacyAndTerms,
    });

    return new Promise((resolve, reject) => {
        xhr.end((err, res) => {
            if (err) {
                if (res.status !== 400) {
                    reject(null);
                }

                const errors: { [key: string]: string } = {};
                const json = JSON.parse(res.text) as { errors: Error[] };

                json.errors.forEach(error => (errors[error.param] = error.message));
                reject(errors);
            } else {
                resolve(res.body);
            }
        });
    });
}



// WEBPACK FOOTER //
// ./js/launch/common/xhr/accounts.ts